module.exports = __webpack_public_path__ + "img/Filterslines.0d794bb8.svg";